import { Box, styled } from '@mui/material';

export const Page = styled(Box)({
	width: '100%',
	minHeight: '100vh',
});
